import type { ColorType } from 'common/helpers'

import type { IWebGlRender, Nullable } from '../../types'

export const prepareRendering = (renders: IWebGlRender[]) => {
  renders.length = 0
}

export const addRender = (renders: IWebGlRender[], render: Nullable<IWebGlRender>) => {
  if (!render) return

  renders.push(render)
}

export const colorTypeToNormFloat32Array = (
  hex: ColorType,
  alphaChannel: number = 1,
): Float32Array => {
  const rgba = new Float32Array(4)
  rgba[0] = parseInt(hex.substring(1, 3), 16) / 255
  rgba[1] = parseInt(hex.substring(3, 5), 16) / 255
  rgba[2] = parseInt(hex.substring(5, 7), 16) / 255
  rgba[3] = alphaChannel

  return rgba
}
